export default __webpack_public_path__ + "static/media/second-trainer.56b7321c.jpg";